export const API = {
  merchant: {
    registerStart: '/auth/otp/register/start',
    confirmOTP: '/auth/otp/confirm',
    resendOTP: '/auth/resend-otp',
    registerInputPwd: '/auth/otp/register/end',
    forgotPassword: '/auth/forgot-password',
    merchantLogin: '/auth/login',
    merchantOnboarding: '/account/merchant-onbrd',
    updateProduct: '/merchant/products',
    changePassword: '/merchant/profile/change-password',
    resetPassword: '/auth/reset-password',
    refresh: 'auth/i/token/refresh',
  },
  location: '/regions/vn',
  storeFront: {
    merchantDetail: '/store/merchants'
  },
  merchantCMS: {
    changePassword: '/account/password',
    products: '/merchant/products',
    profile: '/merchant/profile',
    countStatus: '/merchant/products/status-count'
  },
  medusa: {
    productCategories: '/store/product-categories',
    products: '/store/products',
    productsDetail: '/merchant/products',
  },
  helper: {
    upload: '/helper/uploads/',
    image: '/utils/upload-images'
  },
  address: {
    getAllAddress: 'merchant/address',
    getDetailAddress: 'merchant/address/{id}',
    deleteAddress: 'merchant/address/{id}',
    createAddress: 'merchant/address',
    updateAddress: 'merchant/address/{id}',
  },
  product: {
    tags: 'store/product-tags',
    products: 'store/products'
  },
  //orders
  orders: {
    seller: '/seller',
    sellerDetail: '/user/{id}',
    sellerCountStatusMonth: 'seller/count/status/month',
    sellerCountStatusAllTime: 'seller/count/status/all-time',
    sellerCancel: '/seller/cancel',
    sellerRefund: '/seller/refund',
    sellerConfirmOrder: '/seller/confirm',
    sellerConfirmOrderSuccess: 'seller/{id}/status',
    sellerOrderNotes: '/seller/orders/{id}/notes',
    sellerOrderNoteDetail: '/seller/orders/{id}/notes/{noteId}',
  },
  noti: {
    getListNoti: '/users',
    getCountNoti: 'users/count',
    readMarkNotiById: 'users/mark/{id}',
    readMarkNotiAll: 'users/mark-all',
    deleteNoti: 'users/{id}',
  },
  delivery: {
    shippingProviders: '/seller/shipping-providers',
    updateShippingProviders: 'seller/shipping-providers/toggle/multiple',
    pickupTime: 'seller/pickup-time/1'
  }
}

export const ENV = {
  FUNONG_DOMAIN: process.env.REACT_APP_FUNONG_DOMAIN,
  STORE_FUNONG_DOMAIN: process.env.REACT_APP_STORE_FUNONG_DOMAIN,
}
